import $t from './$t';
import store from '@/store';

export default {
    computed: {
        $t() {
            const lang = store.state.selectedLang;

            return (textKey, optionalVal, optionalVars) => {
                return $t(lang, textKey, optionalVal, optionalVars);
            }
        }
    }
}